import { Answer } from "../Models/AnswerType"

import ImageJatteBra from "../Assets/Images/Smiley/jättebra.svg"
import ImageBra from "../Assets/Images/Smiley/bra.svg"
import ImageSadar from "../Assets/Images/Smiley/sådär.svg"
import ImageDaligt from "../Assets/Images/Smiley/dåligt.svg"
import ImageJatteDaligt from "../Assets/Images/Smiley/jättedåligt.svg"
import ImageTrott from "../Assets/Images/Smiley/trött.svg"
import ImagePigg from "../Assets/Images/Smiley/pigg.svg"

import ImageWidgetDaligt from "../Assets/Images/Widgetansikten/dåligt.svg"
import ImageWidgetSadar from "../Assets/Images/Widgetansikten/sådär.svg"
import ImageWidgetBra from "../Assets/Images/Widgetansikten/bra.svg"
import ImageWidgetJatteBra from "../Assets/Images/Widgetansikten/jättebra.svg"
import ImageWidgetJatteDaligt from "../Assets/Images/Widgetansikten/jättedåligt.svg"


//These Arrays contains Data concerned with rendering certain elements on QuestionsPage,
//and Data to send to the collectedAnswers state.
export const selectConfigFull: { [key: string]: Answer[] } = {
    answer1: [
        {
            imgUrl: ImageWidgetDaligt,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer1.imgAlt1",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer1.textContent1",
            answerData: { value: 1, description: "dåligt" }
        },
        {
            imgUrl: ImageWidgetSadar,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer1.imgAlt2",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer1.textContent2",
            answerData: { value: 2, description: "sådär" }
        },
        {
            imgUrl: ImageWidgetJatteBra,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer1.imgAlt3",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer1.textContent3",
            answerData: { value: 3, description: "bra" }
        }
    ],
    answer2: [
        {
            imgUrl: ImageTrott,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer2.imgAlt1",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer2.textContent1",
            answerData: { value: 1, description: "trött" }
        },
        {
            imgUrl: ImageWidgetSadar,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer2.imgAlt2",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer2.textContent2",
            answerData: { value: 2, description: "sådär" }
        },
        {
            imgUrl: ImagePigg,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer2.imgAlt3",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer2.textContent3",
            answerData: { value: 3, description: "pigg" }
        }
    ],
    answer3: [
        {
            imgUrl: ImageWidgetDaligt,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer3.imgAlt1",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer3.textContent1",
            answerData: { value: 1, description: "nej" }
        },
        {
            imgUrl: ImageWidgetSadar,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer3.imgAlt2",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer3.textContent2",
            answerData: { value: 2, description: "kanske" }
        },
        {
            imgUrl: ImageWidgetJatteBra,
            imgAlt: "evaluationTool.evaluationQuestion.answerFull.answer3.imgAlt3",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerFull.answer3.textContent3",
            answerData: { value: 3, description: "ja" }
        }
    ]
}

export const selectConfigLight: { [key: string]: Answer[] } = {
    answer1: [
        {
            imgUrl: ImageWidgetDaligt,
            imgAlt: "evaluationTool.evaluationQuestion.answerBeforeAfter.imgAlt1",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerBeforeAfter.textContent1",
            answerData: { value: 1, description: "dåligt" }
        },
        {
            imgUrl: ImageWidgetSadar,
            imgAlt: "evaluationTool.evaluationQuestion.answerBeforeAfter.imgAlt2",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerBeforeAfter.textContent2",
            answerData: { value: 2, description: "sådär" }
        },
        {
            imgUrl: ImageWidgetBra,
            imgAlt: "evaluationTool.evaluationQuestion.answerBeforeAfter.imgAlt3",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerBeforeAfter.textContent3",
            answerData: { value: 3, description: "bra" }
        }
    ],
}

export const sliderConfigFull: { [key: string]: Answer[] } = {
    answer1: [
        {
            imgUrl: ImageWidgetJatteDaligt,
            imgAlt: "smiley-jättedåligt",
            typographyTextContent: "JÄTTEDÅLIGT",
            answerData: { value: 1, description: "jättedåligt" }
        },
        {
            imgUrl: ImageWidgetDaligt,
            imgAlt: "smiley-dåligt",
            typographyTextContent: "DÅLIGT",
            answerData: { value: 2, description: "dåligt" }
        },
        {
            imgUrl: ImageWidgetSadar,
            imgAlt: "smiley-sådär",
            typographyTextContent: "SÅDÄR",
            answerData: { value: 3, description: "sådär" }
        },
        {
            imgUrl: ImageWidgetBra,
            imgAlt: "smiely-bra",
            typographyTextContent: "BRA",
            answerData: { value: 4, description: "bra" }
        },
        {
            imgUrl: ImageWidgetJatteBra,
            imgAlt: "smiely-jättebra",
            typographyTextContent: "JÄTTEBRA",
            answerData: { value: 5, description: "jättebra" }
        }
    ],
    answer2: [
        {
            imgUrl: ImageTrott,
            imgAlt: "smiley-trött",
            typographyTextContent: "JÄTTETRÖTT",
            answerData: { value: 1, description: "jättetrött" }
        },
        {
            imgUrl: ImageTrott,
            imgAlt: "smiley-trött",
            typographyTextContent: "TRÖTT",
            answerData: { value: 2, description: "trött" }
        },
        {
            imgUrl: ImageWidgetSadar,
            imgAlt: "smiley-sådär",
            typographyTextContent: "SÅDÄR",
            answerData: { value: 3, description: "sådär" }
        },
        {
            imgUrl: ImagePigg,
            imgAlt: "smiley-pigg",
            typographyTextContent: "PIGG",
            answerData: { value: 4, description: "pigg" }
        },
        {
            imgUrl: ImagePigg,
            imgAlt: "smiley-pigg",
            typographyTextContent: "JÄTTEPIGG",
            answerData: { value: 5, description: "jättepigg" }
        }
    ],
    answer3: [
        {
            imgUrl: ImageWidgetJatteDaligt,
            imgAlt: "smiley-jättedåligt",
            typographyTextContent: "JÄTTENEJ",
            answerData: { value: 1, description: "jättenej" }
        },
        {
            imgUrl: ImageWidgetDaligt,
            imgAlt: "smiley-dåligt",
            typographyTextContent: "NEJ",
            answerData: { value: 2, description: "nej" }
        },
        {
            imgUrl: ImageWidgetSadar,
            imgAlt: "smiley-sådär",
            typographyTextContent: "KANSKE",
            answerData: { value: 3, description: "kanske" }
        },
        {
            imgUrl: ImageWidgetBra,
            imgAlt: "smiley-bra",
            typographyTextContent: "JA",
            answerData: { value: 4, description: "ja" }
        },
        {
            imgUrl: ImageWidgetJatteBra,
            imgAlt: "smiley-jättebra",
            typographyTextContent: "JÄTTEJA",
            answerData: { value: 5, description: "jätteja" }
        }
    ]
}

export const sliderConfigLight: { [key: string]: Answer[] } = {
    answer1: [
        {
            imgUrl: ImageWidgetJatteDaligt,
            imgAlt: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.imgAlt1",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.textContent1",
            answerData: { value: 1, description: "jättedåligt" }
        },
        {
            imgUrl: ImageWidgetDaligt,
            imgAlt: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.imgAlt2",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.textContent2",
            answerData: { value: 2, description: "dåligt" }
        },
        {
            imgUrl: ImageWidgetSadar,
            imgAlt: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.imgAlt3",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.textContent3",
            answerData: { value: 3, description: "sådär" }
        },
        {
            imgUrl: ImageWidgetBra,
            imgAlt: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.imgAlt4",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.textContent4",
            answerData: { value: 4, description: "bra" }
        },
        {
            imgUrl: ImageWidgetJatteBra,
            imgAlt: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.imgAlt5",
            typographyTextContent: "evaluationTool.evaluationQuestion.answerBeforeAfter.answersSlider.textContent5",
            answerData: { value: 5, description: "jättebra" }
        }
    ],
}
